/* eslint-disable react/jsx-props-no-spreading */

import {
    Button, IconButton,
} from '@mui/material'
import VpnLock from '@mui/icons-material/VpnLock'

import Label from 'app/shared-components/Label'

import {
    useDateInputError,
} from '../DateSelect'
import useStyles from './DateTimeZonedSelect.style'
import Zone from './Zone'
import {
    DateTimeZonedState,
} from './DateTimeZonedSelect.types'

type Props = {
    name?: string
    title?: string
    value?: string
    handleSetLocalTime: () => void
    isLocalTime?: boolean
    state: DateTimeZonedState
    showDate: (value?: string) => string
    setOpenDialog: () => void
    handleChange: (value: string) => void
    handleClose: () => void
    disableFuture?: boolean
    disabled?: boolean
    required?: boolean
    isDisableWeekends?: boolean
    className?: string
    setErrors?: (errors: string[]) => void
    setState: (state: DateTimeZonedState) => void
    handleChangeZone: (zone: string) => void
}
const EMPTY_STRING = ''

const DateTimeZonedSelect = ({
    name = EMPTY_STRING,
    title = 'Calendar',
    value = EMPTY_STRING,
    handleSetLocalTime,
    isLocalTime,
    state,
    showDate,
    setOpenDialog,
    disabled,
    required,
    className = EMPTY_STRING,
    setErrors,
    setState,
    handleChange,
    handleChangeZone,
    handleClose,
    disableFuture = false,
    isDisableWeekends = false,
}: Readonly<Props>) => {
    const {
        classes,
        cx,
    } = useStyles()

    const {
        onError,
        isError,
    } = useDateInputError({
        name,
        setFormError: setErrors,
    })

    return (
        <div
            className={cx({
                [classes.pointer]: !disabled,
            }, classes.calendar, className)}
            data-testid={`dateTimeZoned-${name}`}
        >

            <Label
                title={title}
                data-testid="datetime-select-label"
            />
            <div
                className={cx(
                    {
                        [classes.field]: !disabled,
                        [classes.disabled]: disabled,
                        [classes.isRequired]: required,
                        [classes.inputError]: isError,
                    },
                )}
            >
                <div className={cx({
                    [classes.requiredMark]: true,
                    [classes.requiredMarkError]: isError,
                })}
                />
                {disabled ? (
                    <div
                        className={cx(classes.button, classes.disabledInput)}
                    >
                        <div
                            className={classes.calendarInput}
                        >
                            {value ? showDate(value) : '-'}
                        </div>
                    </div>
                ) : (
                    <Button
                        className={classes.button}
                        onClick={setOpenDialog}
                        data-testid={`dateTimeZonedSelect-${name}`}
                    >
                        <div
                            className={classes.calendarInput}
                        >
                            {showDate(value)}
                        </div>
                    </Button>
                )}
            </div>
            <div className={classes.icon}>
                <IconButton
                    size="small"
                    onClick={handleSetLocalTime}
                >
                    <VpnLock
                        className={cx({
                            [classes.pointer]: true,
                            [classes.iconActive]: isLocalTime,
                        })}
                    />
                </IconButton>
                {state.open && (
                    <Zone
                        state={state}
                        setState={setState}
                        handleChange={handleChange}
                        handleChangeZone={handleChangeZone}
                        handleClose={handleClose}
                        disableFuture={disableFuture}
                        isDisableWeekends={isDisableWeekends}
                        onError={onError}
                    />
                )}
            </div>
        </div>
    )
}

export default DateTimeZonedSelect
